<template>
  <container>
    <div class="container">
      <div class="privacy-policy-page page">
        <div class="page__header">
          <h2>Privacy Policy</h2>
        </div>
        <div class="page__card mt-0">
          <div
            class="page__card__content page__card__content--lg"
            v-html="content"
          ></div>
        </div>
      </div>
    </div>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * Privacy Policy page
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import MainLayout from '@/layouts/MainLayout'

export default {
  metaInfo: function() {
    const title = 'Privacy Policy'
    return {
      title: title,
      meta: [
        {
          property: 'og:title',
          content: title
        }
      ]
    }
  },
  components: {
    container: MainLayout
  },

  data() {
    return {
      loading: false,
      error: null
    }
  },

  computed: {
    ...mapState({
      privacyPolicy: state => state.support.privacyPolicyDetails
    }),

    content() {
      if (this.error) return this.error
      return this.privacyPolicy ? this.privacyPolicy.content : null
    }
  },

  methods: {
    ...mapActions({
      getPrivacyPolicyDetails: 'support/getPrivacyPolicyDetails'
    }),

    ...mapMutations({
      clearPrivacyPolicyDetails: 'support/clearPrivacyPolicyDetails'
    }),

    async fetchPrivacyPolicy() {
      if (this.loading) return
      this.error = null
      this.loading = true
      await this.getPrivacyPolicyDetails()
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.error = `Can't seem to fetch the privacy policy, please try later or refresh the page`
        })
    }
  },

  created() {
    this.clearPrivacyPolicyDetails()
    this.fetchPrivacyPolicy()
  }
}
</script>
<style scoped lang="scss">
.privacy-policy-page {
  .page__card__content {
    padding-top: 50px;
  }
}
</style>
